import type { FaireProductEntity } from "../../entity_types/product";

export const p_mh2wy6kvda: FaireProductEntity = {
  token: "p_mh2wy6kvda",
  type: "product",
  name: "24K Gold Filled Clear CZ Bezel Stud Earring | AD-672",
  brandToken: "b_374b66mxaz",
  brandName: "Aim Eternal",
  imageUrl:
    "https://cdn.faire.com/fastly/4b847ab958a4ed3cf98316497425a43dd7aa8f628730f37b06838a07d607aa5a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d398ed5aed0799578ec2dfa2586d64bfd78045c2624bac3379f0ae7f07f3d58.jpeg",
    "https://cdn.faire.com/fastly/a959afd5501f74efc78adc425228de7ebedacd9bbbe7c1ffd44c7c196d621723.jpeg",
    "https://cdn.faire.com/fastly/85150ab62a56495486b6e5a19d151324cca55d5c2d52ce4c869e78c8cf9174a6.jpeg",
  ],
  priceDollars: 7.69,
  description:
    "Material: Brass, 24K Gold-Filled, Cubic Zirconia\nSize: 10mm x 7.9mm x 16.2mm\nQuantity: 1 Pair\nColor: Gold\n",
  tags: [],
  msrpDollars: 15.38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:09.758Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
